import { CopyIcon } from 'lucide-react'
import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { useOrganizationViewUrl } from '../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../../../utils/routing/reactRoute'
import { BillsTableRow } from '../../../../types/billsTableRow'
import { BillsTableActionType } from '../../enums/billsTableActionType'
import { BillsTableAction } from '../../types/billsTableAction'

/**
 * @todo Handle localization
 * @see https://linear.app/shine-co/issue/EXP-357/web-add-localization
 */
export const useDuplicateBillAction = (row: BillsTableRow): BillsTableAction => {
  const navigate = useNavigate()
  const location = useLocation()
  const { url: duplicateBillUrl } = useOrganizationViewUrl(reactRoute.organization.bills.getDuplicateRoute(row.id))

  const navigateToDuplicate = useCallback(() => {
    if (!duplicateBillUrl) {
      return
    }

    // Preserve the list's search params so the user lands back on the same filtered list
    navigate(`${duplicateBillUrl}${location.search}`)
  }, [duplicateBillUrl, location.search, navigate])

  return {
    type: BillsTableActionType.Duplicate,
    label: 'Duplicate',
    icon: CopyIcon,
    onClick: navigateToDuplicate,
  }
}
